import { render } from "./Verhalen.vue?vue&type=template&id=64f2f93e&scoped=true"
import script from "./Verhalen.vue?vue&type=script&lang=js"
export * from "./Verhalen.vue?vue&type=script&lang=js"

import "./Verhalen.vue?vue&type=style&index=0&id=64f2f93e&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f2f93e"]])

export default __exports__